import { useS4LContext } from '@s4l/react-context'
import { Language } from '@s4l/stayforlong/shared/domain/Language'
import { Locale } from '@s4l/stayforlong/shared/domain/Locale'
import { useUseCase } from '@s4l/utils/hooks/useUseCase'
import { Script } from '@s4l/react-facade'
import React, { useEffect, useRef, useState } from 'react'
import debug from 'debug'

const log = debug('s4l:uikit:TrustPilotWidgetContent')

declare global {
  interface Window {
    Trustpilot: any // eslint-disable-line @typescript-eslint/no-explicit-any
  }
}

interface TrustPilotWidgetContentProps {
  theme: 'dark' | 'light'
}

const TrustPilotWidgetContent = ({ theme }: TrustPilotWidgetContentProps) => {
  const { i18n } = useS4LContext()
  const {
    data: language = Language.default(),
    loading,
    error,
  } = useUseCase('GetCurrentLanguageSharedUseCase')

  if (error) {
    log('Error in GetCurrentLanguageSharedUseCase')
  }

  const trustPilotRef = useRef<HTMLDivElement>(null)
  const [isLoaded, setLoaded] = useState(false)

  const locale = Locale.createOrNull({ value: i18n.locale })
  const isInvalid =
    !locale || !locale.isSupportedByTrustPilot() || !language.isSupportedByTrustPilot()

  useEffect(() => {
    if (!isLoaded && !isInvalid && globalThis.window?.Trustpilot && !loading && !error) {
      globalThis.window.Trustpilot.loadFromElement(trustPilotRef.current, true)
      setLoaded(true)
    }
  }, [isLoaded, isInvalid, loading, error])

  if (isInvalid) {
    return null
  }

  return (
    <>
      <div
        ref={trustPilotRef}
        className="trustpilot-widget"
        data-locale={locale.value}
        data-template-id="5419b6ffb0d04a076446a9af"
        data-businessunit-id="585c27800000ff00059990ca"
        data-style-width="100%"
        data-style-height="20px"
        data-theme={theme}
        data-stars="4,5"
        data-review-languages={language?.value}
        data-font-family="Roboto"
      >
        <a
          href="https://uk.trustpilot.com/review/stayforlong.com"
          target="_blank"
          rel="noreferrer noopener"
        >
          Trustpilot
        </a>
      </div>
      <Script
        id="trustpilot-widget"
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        strategy="afterInteractive"
      />
    </>
  )
}

TrustPilotWidgetContent.displayName = 'TrustPilotWidgetContent'
export default TrustPilotWidgetContent
